/*
 * Jira Ticket:
 * Updated Date: Tue, 21st Apr 2020, 10:19:21 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import uploadFile from './UPLOAD_FILE';

export const UpdateTowerMutation = gql`
  mutation UpdateTower(
    $id: ID!
    $siteId: ID!
    $platformHeight: Int!
    $towerTypeId: ID!
    $notes: String!
    $files: [ID!]
  ) {
    data: updateTower(
      id: $id
      siteId: $siteId
      platformHeight: $platformHeight
      towerTypeId: $towerTypeId
      notes: $notes
      files: $files
    ) {
      id
      site {
        id
        name
        project {
          id
          name
          organisation {
            id
            name
          }
        }
      }
      createdAt
      type {
        id
        name
      }
      status
      tag
      platformHeight
      notes
      files {
        id
        url
        filename
      }
    }
  }
`;

export default async ({ client, params }) => {
  try {
    params.data.towerTypeId = params.data.type.id;
    params.data.siteId = params.data.site.id;
    if (params.data.files) {
      const uploadRequest = await uploadFile({
        client,
        files: params.data.files,
      });
      const filesToSend = Array.from(params.data.files);
      // if we had files to update
      if (uploadRequest) {
        let uploadRequestIndex = 0; // use this to go through the uploadRequest array
        for (let i = 0; i < filesToSend.length; i++) {
          let file = filesToSend[i];
          if (file.hasOwnProperty('rawFile')) {
            filesToSend[i] = uploadRequest.data.data.files[uploadRequestIndex];
            uploadRequestIndex += 1;
          }
        }
      }
      params.data.files = filesToSend.map(x => x.id);
    } else {
      params.data.files = [];
    }
    return client.mutate({
      mutation: UpdateTowerMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
